// Self-contained data for the Yobhelle’s Meetings & Banquets events concept website.
export const BUSINESS = {
  "slug": "yobhelles-meetings-banquets-concept",
  "media": {
    "hero": "/events/yobhelles/06.jpg",
    "logo": "/events/yobhelles/09.jpg",
    "gallery": [
      "/events/yobhelles/01.jpg",
      "/events/yobhelles/02.jpg",
      "/events/yobhelles/03.jpg",
      "/events/yobhelles/04.jpg",
      "/events/yobhelles/05.jpg",
      "/events/yobhelles/07.jpg"
    ]
  },
  "name": "Yobhelle’s Meetings & Banquets",
  "shortName": "Yobhelle’s",
  "kind": "venue",
  "layout": "professional",
  "location": "Toledo City, Cebu",
  "address": "Toledo City, Cebu, Philippines",
  "eyebrow": "Meetings · conferences · banquets",
  "headline": "A practical local venue for business and celebration.",
  "intro": "A professional booking journey for meetings, conferences, catered occasions and private events—without turning every inquiry into a wedding enquiry.",
  "venueFeature": "Meetings and banquet venue",
  "services": [
    "Small to medium meetings",
    "Conferences",
    "Private events",
    "Venue rental",
    "Catering enquiries",
    "Audiovisual service enquiries"
  ],
  "proof": [
    "Business and private-event positioning",
    "Substantial public check-in history",
    "Local Toledo presence"
  ],
  "reviewSnapshot": "Public directories differed between roughly 4 and 7 reviews when checked in August 2026. Confirm the current total on the live listing.",
  "reviews": [],
  "contact": {
    "phone": "(032) 383-0200",
    "phoneHref": "+63323830200",
    "facebook": "https://www.facebook.com/FourFoodGroups/"
  },
  "sources": [
    "https://www.facebook.com/FourFoodGroups/",
    "https://www.bizippines.com/yobhelles-meetings-and-banquets-032-383-0200",
    "https://www.cybo.com/PH-biz/yobhelles-meetings-and-banquets"
  ]
};
